module.exports = __webpack_public_path__ + "app/modals/device-action-refresh-modal.view.html";